import { useContext, useEffect, useState } from "react";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router";
import {
  DifficultWord,
  SessionStatus,
  Stored,
  StudentOpinion,
  PopulatedVotingSession,
} from "../../../types";
import SocketContext from "../../../context/socket-context";
import logo from "../../../images/logo.png";
import Session from "./session";
import Results from "./results";
import StatementResult from "../../../components/student/statement_result";
import APIclient from "../../../api-client";
import { DifficultWordsContext } from "../../../context";
import Footer from "../../../components/footer";
import clsx from "clsx";

export default function SessionWrapper() {
  const socket = useContext(SocketContext);
  const navigate = useNavigate();
  const { code } = useParams();
  const location = useLocation();
  const [status, setStatus] = useState<SessionStatus>(SessionStatus.Draft);
  const [session, setSession] = useState<PopulatedVotingSession | null>(null);
  const [answers, setAnswers] = useState<Array<Stored<StudentOpinion>>>([]);
  const [difficultWords, setDifficultWords] = useState<Array<DifficultWord>>(
    [],
  );

  const isResult = location.pathname.endsWith("results");

  useEffect(() => {
    if (code === undefined) return;

    APIclient.sessions
      .read(code)
      .then((session) => {
        setSession(session);
        setStatus(session.state);
        setAnswers(session.studentOpinions);
      })
      .catch(() =>
        // Any error is assumed to be a 404, since axios doesn't give us more specific errors
        navigate("/join?error=INVALID_CODE"),
      );
    APIclient.difficultWords.index().then(setDifficultWords);
  }, [code]);

  useEffect(() => {
    if (code === undefined) return;

    socket.emit("subscribe", code);
    socket.on("updateStatus", setStatus);

    return () => {
      socket.off("updateStatus", setStatus);
    };
  }, [code]);

  return (
    <DifficultWordsContext.Provider value={difficultWords}>
      <main
        className={clsx("voting-session", {
          "voting-session--shrink": isResult,
        })}
      >
        <img src={logo} alt="" className="voting-session__logo" />
        {session !== null && (
          <Routes>
            <Route
              path=""
              index
              element={
                <Session
                  votingSession={session}
                  status={status}
                  setAnswers={setAnswers}
                  answers={answers}
                />
              }
            />
            <Route
              path="results"
              element={<Results votingSession={session} answers={answers} />}
            />
            <Route
              path="results/:index"
              element={
                <StatementResult votingSession={session} answers={answers} />
              }
            />
          </Routes>
        )}
      </main>
      {isResult && <Footer />}
    </DifficultWordsContext.Provider>
  );
}
